<!-- <div>
  <table style="width: 100%;">
    <tr>
      <th>
        <header>From Our Kitchen to Your Celebration</header>
      </th>
      <th class="rowup"> <img src="assets/images/logo.jpg" class="logo"></th>
    </tr>
  </table>
  <app-floating-div></app-floating-div> -->
<!-- <table style="width: 100%;">
    <tr>
      <th class="xy1"></th>
      <th class="xy1">
        <nav>
          <a routerLink="/menu" routerLinkActive="active" class="newmenu">Home</a>
          <a routerLink="/about" routerLinkActive="active" class="newmenu">Know Us</a>
          <a routerLink="/reviews" routerLinkActive="active" class="newmenu">Reviews</a>
          <a routerLink="/reviews" routerLinkActive="active" class="newmenu">Find Us</a>
          <a routerLink="/reviews" routerLinkActive="active" class="newmenu">Gallery</a>
        </nav>
        <app-mainmenu></app-mainmenu>
      </th>
     
  </table> -->
<div>
  
  <div class="header">
    <img src="assets/images/logosp.png">
    <!-- <h1>catering</h1> -->
    <span>...Our Kitchen to Your Celebration</span>
    <button mat-icon-button class="callbutton" (click)="callus()">
      
      <mat-icon class="btn-icongreen">phone</mat-icon>
    </button>

  </div>

  <div class="topnav">
    <div class="center">
      <button mat-raised-button (click)="openMenuHome()" class="buttoncolor">Home</button>
      <button mat-raised-button (click)="openMenuAboutUs()" class="buttoncolor">About Us</button>
      <button mat-raised-button (click)="openMenuReviews()" class="buttoncolor">Reviews</button>
      <button mat-raised-button (click)="openMenufindus()" class="buttoncolor">Find Us</button>
      <button mat-raised-button (click)="openMenuAdmin()" class="buttoncolor">Admin</button>
    </div>
  </div>
  <div class="mobilenav">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon class="btn-icongreen">menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu" class="customize">
      <button mat-menu-item (click)="openMenuHome()">
        <mat-icon class="btn-icon">home</mat-icon>
        <span style="font-family: Comic Sans MS">Home</span>
      </button>
      <button mat-menu-item (click)="openMenuAboutUs()">
        <mat-icon class="btn-icon">business</mat-icon>
        <span style="font-family: Comic Sans MS">About Us</span>
      </button>
      <button mat-menu-item (click)="openMenuReviews()">
        <mat-icon class="btn-icon">rate_review</mat-icon>
        <span style="font-family: Comic Sans MS">Reviews</span>
      </button>
      <button mat-menu-item (click)="openMenufindus()">
        <mat-icon class="btn-icon">map</mat-icon>
        <span style="font-family: Comic Sans MS">Find Us</span>
      </button>
       <button mat-menu-item (click)="openMenugallery()">
        <mat-icon class="btn-icon">photo</mat-icon>
        <span style="font-family: Comic Sans MS">Gallery</span>
      </button>
     
    </mat-menu>
  </div>
</div>


<app-spinner>
<router-outlet></router-outlet>
</app-spinner>

<div class="footer">
  <h3>Follow Me</h3>
  <div class="rounded-social-buttons">
    <a class="social-button facebook" href="https://www.facebook.com/" target="_blank"><i
        class="fab fa-facebook-f"></i></a>
    <a class="social-button linkedin" href="https://www.linkedin.com/" target="_blank"><i
        class="fab fa-linkedin"></i></a>
    <a class="social-button youtube" href="https://www.youtube.com/" target="_blank"><i class="fab fa-youtube"></i></a>
    <a class="social-button instagram" href="https://www.instagram.com/" target="_blank"><i
        class="fab fa-instagram"></i></a>
  </div>
  <p>&copy; 2025 SpiceTrail. All rights reserved.</p>
  <p>Powered by </p> <img class="companyImage" src="assets/images/SS.png">
</div>